/**
 * Agent contact JS controller.
 *
 * This class handles the showing and hiding of items on the agent contact page according to url parameters.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ContactRequest. This gets mapped with the keyword ContactRequest and its
 * docready method is fired automatically on pages where there's a
 * class called 'ContactRequest' on the html tag.
 */
class ContactRequest {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        this.agentsContainer = $( '#js-agents' );
        this.defaultForm     = $( '#js-default-form' );
        this.agentForm       = $( '#js-agent-form' );
        this.agents          = $( '.js-result' );
    }

    /**
     * This hides the items and shows the filters when javascript is loaded. Otherwise
     * users can see them all and there's no need for filters.
     */
    initialLoad() {

        // Check if there's a agent ID in the url and match
        const agentIdFromUrl = Theme.Common.getUrlParameter( 'agent' );

        this.agents.each( ( index, agent ) => {

            if ( agent.dataset.id === agentIdFromUrl ) {

                const agentData = {
                    name: agent.dataset.name,
                    phone: agent.dataset.phone,
                    email: agent.dataset.email,
                    address: agent.dataset.address,
                    city: agent.dataset.city
                };

                // Remove hidden classes from agent specific elements when
                // ID from the url parameter is matched and hide the default form.
                $( agent ).removeClass( 'js-hidden' );
                this.agentsContainer.removeClass( 'js-hidden' );
                this.agentForm.removeClass( 'js-hidden' );
                this.defaultForm.addClass( 'js-hidden' );
                this.appendAgentDataToForm( agentData );
            }
        });


    }

    appendAgentDataToForm( agentData ) {

        this.agentForm.find( 'form' ).append(
            '<input type="hidden" name="agent-name" value="' + agentData.name + '">',
            '<input type="hidden" name="agent-phone" value="' + agentData.phone + '">',
            '<input type="hidden" name="agent-email" value="' + agentData.email + '">',
            '<input type="hidden" name="agent-address" value="' + agentData.address + '">',
            '<input type="hidden" name="agent-city" value="' + agentData.city + '">'
        );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();
        this.initialLoad();
    }

}

// Export the class reference.
module.exports = ContactRequest;



// WEBPACK FOOTER //
// ./assets/scripts/contactrequest.js